import Vue from 'vue';
import CpLobbyFlowDialog from '../dialogs/LobbyFlowDialog.vue';

// Create a global modal component that will be mounted to the body
const GlobalContactRepsModal = {
  name: 'GlobalContactRepsModal',
  components: {
    CpLobbyFlowDialog
  },
  data() {
    return {
      showDialog: false,
      commentToRep: 'I am writing to express my views on important issues affecting our community and to urge you to consider the perspectives of your constituents.',
      callback: null,
      newsArticle: null,
      originalPostType: null,
      originalPostId: null,
      politician: null
    };
  },
  mounted() {
    // Listen for open-lobby-dialog events
    this.eventHandler = (event) => {
      this.handleLobbyDialogEvent(event.detail);
    };
    
    document.addEventListener('open-lobby-dialog', this.eventHandler);
    
    // Process existing buttons
    this.processContactRepsButtons();
    
    // Set up MutationObserver to watch for dynamically added content
    this.setupMutationObserver();
  },
  beforeDestroy() {
    if (this.eventHandler) {
      document.removeEventListener('open-lobby-dialog', this.eventHandler);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    handleLobbyDialogEvent(data) {
      this.showDialog = true;
      this.commentToRep = data.commentToRep || 'I am writing to express my views on important issues affecting our community and to urge you to consider the perspectives of your constituents.';
      this.callback = data.callback || null;
      this.newsArticle = data.newsArticle || null;
      this.originalPostType = data.originalPostType || null;
      this.originalPostId = data.originalPostId || null;
      this.politician = data.politician || null;
    },
    
    handleLobbyDialogClose() {
      this.showDialog = false;
      // Execute callback if it exists
      if (this.callback && typeof this.callback === 'function') {
        this.callback();
        this.callback = null;
      }
    },
    
    processContactRepsButtons() {
      // Find all contact-reps buttons in the document
      const buttons = document.querySelectorAll('.contact-reps-button');
      buttons.forEach(button => {
        this.setupButtonHandler(button);
      });
    },
    
    setupButtonHandler(button) {
      // Ensure button is not editable
      button.setAttribute('contenteditable', 'false');
      
      // Add click handler if not already present
      if (!button.hasAttribute('data-contact-reps-handler')) {
        button.setAttribute('data-contact-reps-handler', 'true');
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const originalText = button.textContent || button.innerText;
          button.textContent = 'Loading...';
          button.disabled = true;
          
          // Find the closest Vue component to get context
          const vueComponent = this.findVueComponent(button);
          
                      // Dispatch the same event as the global handler
            const event = new CustomEvent('open-lobby-dialog', {
              detail: {
                politician: null,
                commentToRep: 'I am writing to express my views on important issues affecting our community and to urge you to consider the perspectives of your constituents.',
                newsArticle: vueComponent?.news || null,
                originalPostType: vueComponent?.type || null,
                originalPostId: vueComponent?.news?.id || vueComponent?.id || null,
                callback: function() {
                  button.textContent = originalText;
                  button.disabled = false;
                }
              }
            });
          document.dispatchEvent(event);
        });
      }
    },
    
    findVueComponent(element) {
      // Try to find the Vue component that contains this element
      let current = element;
      while (current && current !== document.body) {
        if (current.__vue__) {
          return current.__vue__;
        }
        current = current.parentElement;
      }
      return null;
    },
    
    setupMutationObserver() {
      if (typeof MutationObserver !== 'undefined') {
        this.observer = new MutationObserver((mutations) => {
          let shouldProcess = false;
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.classList && node.classList.contains('contact-reps-button')) {
                    shouldProcess = true;
                  } else if (node.querySelector && node.querySelector('.contact-reps-button')) {
                    shouldProcess = true;
                  }
                }
              });
            }
          });
          if (shouldProcess) {
            this.processContactRepsButtons();
          }
        });
        
        this.observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  },
  template: `
    <CpLobbyFlowDialog
      v-if="showDialog"
      :showDialog="showDialog"
      type="none"
      :commentToRep="commentToRep"
      :newsArticle="newsArticle"
      :politician="politician"
      :callback="callback"
      shareMessageInComments
      :originalPostType="originalPostType"
      :originalPostId="originalPostId"
      @close="handleLobbyDialogClose"
    />
  `
};

// Create and mount the global modal
let globalModalInstance = null;

function createGlobalModal() {
  if (globalModalInstance) {
    return globalModalInstance;
  }
  
  // Create a container for the modal
  const modalContainer = document.createElement('div');
  modalContainer.id = 'global-contact-reps-modal';
  document.body.appendChild(modalContainer);
  
  // Create Vue instance
  globalModalInstance = new Vue({
    render: h => h(GlobalContactRepsModal)
  });
  
  globalModalInstance.$mount(modalContainer);
  return globalModalInstance;
}

// Vue plugin
const ContactRepsPlugin = {
  install(Vue, options) {
    // Create global modal when plugin is installed
    Vue.nextTick(() => {
      createGlobalModal();
    });
    
    // Add a global method to manually trigger the dialog
    Vue.prototype.$openContactRepsDialog = function(data) {
      const event = new CustomEvent('open-lobby-dialog', {
        detail: data
      });
      document.dispatchEvent(event);
    };
  }
};

export default ContactRepsPlugin; 